export async function fetchAssetAsBase64(src: string) {
    if (!fetch) return "";

    const response = await fetch(src);
    const blob = await response.blob();
    const base64 = await blobToBase64(blob);
    return base64;
}

async function blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve) => {
        const reader = new window.FileReader();
        reader.onload = function () {
            if (this.result instanceof ArrayBuffer) {
                resolve(arrayBufferToString(this.result));
                return;
            }
            resolve(this.result);
        };
        reader.readAsDataURL(blob);
    });
}

function arrayBufferToString(buffer: ArrayBuffer): string {
    var arr = new Uint8Array(buffer);
    var str: string = String.fromCharCode.apply(String, arr);
    if (/[\u0080-\uffff]/.test(str)) {
        throw new Error(
            "this string seems to contain (still encoded) multibytes"
        );
    }
    return str;
}
